angular.module('impactx.userlist').controller('UserListCtrl', ['dataGen',
    'LoginService',
    '$securityManager',
    'selectedListItems',
    'ListPrintService',
    'ToastService',
    'ListHelperService',
    '$scope',
    '$redirect',
    'TranslationService',
    'ConfirmationService',
    'PartialDialogsService',
    '$mdDialog',
    'AppConfiguration',
    'ixaUserActions',
    UserListController]);

function UserListController(dataGen, LoginService, $securityManager, selectedListItems, ListPrintService, ToastService,
                            ListHelperService, $scope, $redirect, TranslationService, ConfirmationService, PartialDialogsService,
                            $mdDialog, AppConfiguration, ixaUserActions) {
    var ctrl = this;

    PartialDialogsService.setCurrentList(PartialDialogsService.TYPE.USER, "userlist");

    this.getMaserDataLink = function() {
        return "personaldata/" + selectedListItems.getFirstSelectedId();
    };

    this.getSettingsLink = function() {
        return "usersettings/" + selectedListItems.getFirstSelectedId();
    };

    this.getMessagesLink = function() {
        return "usermessages/" + selectedListItems.getFirstSelectedId();
    };

    this.getControlLink = function() {
        return "usercontrol/" + selectedListItems.getFirstSelectedId();
    };

    this.getGroupsLink = function() {
        return "userauthorizations/" + selectedListItems.getFirstSelectedId();
    };

    this.getDelegationLink = function() {
        return "userdelegation/" + selectedListItems.getFirstSelectedId();
    };

    this.getCXMLExportLink = function() {
        return "cxmlcatalogexport/" + selectedListItems.getFirstSelectedId();
    };

    this.getCustomerCompaniesLink = function() {
        return "customercompanies/" + selectedListItems.getFirstSelectedId();
    };

    this.canGhostLogin = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canLogin == 1 && allowAction();
    };

    // Row cell `ghostLoginActions` (IOBL-14309): the backend delivers the ghost login permissions
    // per row fully evaluated as `can…` booleans; the frontend only adds the selection state.
    var ghostLoginActions = function() {
        var item = selectedListItems.getFirstSelectedItem();
        return (item && angular.isObject(item.ghostLoginActions)) ? item.ghostLoginActions : null;
    };

    this.canDirectGhostLogin = function() {
        var actions = ghostLoginActions();
        if (!actions) {
            // Missing cell (older backend): fall back to the previous canLogin-only behavior.
            return ctrl.canGhostLogin();
        }
        return selectedListItems.isSingleSelection() && !!actions.canDirectGhostLogin && allowAction();
    };

    this.canRequestGhostLogin = function() {
        var actions = ghostLoginActions();
        return selectedListItems.isSingleSelection() && !!(actions && actions.canRequestGhostLogin) && allowAction();
    };

    this.isGhostRequestPending = function() {
        var actions = ghostLoginActions();
        return selectedListItems.isSingleSelection() && !!(actions && actions.isGhostRequestPending) && allowAction();
    };

    this.canEditCustomerCompanies = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canEditCustomerCompany
            && selectedListItems.getFirstSelectedItem().canEditCustomerCompany.value && allowAction();
    };

    this.canSetNoOrder = function() {
        return selectedListItems.isMultiSelection() && AppConfiguration.get('useNoOrder') && allowAction();
    };

    this.canApproveAndDeny = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().registrationStatusFilter == 2 && allowAction();
    };

    this.canDelete = function() {
        if (selectedListItems.isMultiSelection()) {
            var items = selectedListItems.getSelectedItems();
            for (var i = 0; i < items.length; i++) {
                if ((items[i].canDelete !== "1" && items[i].canDelete !== 1) || items[i].deleted) {
                    return false;
                }
            }
            return true;
        }
        else {
            return false;
        }
    };

    this.canGhostLogout = function () {
        return selectedListItems.isSingleSelection()
            && selectedListItems.getFirstSelectedItem().canLogout
            && selectedListItems.getFirstSelectedItem().canLogout.value
            && allowAction();
    }

    ctrl.isDisabledUser = function(userRowData) {
        return (userRowData && (userRowData.usrstatus === '110'));
    };

    this.getAvatarShadow = function(row) {
        if(row) {
            if(ctrl.isDisabledUser(row)) {
                return '#444444 0px 0px 10px 4px';
            }

            if(row.isLoggedIn) {
                return 'red 0px 0px 10px 4px';
            }
        }

        return 'none';
    };

    this.getCellDecoration = function(name, rowData, defaultValue) {
        if(name && rowData) {
            if(name === 'avatar-shadow') {
                return ctrl.getAvatarShadow(rowData);
            }
            if(name === 'grey-image') {
                return ctrl.isDisabledUser(rowData);
            }

            return 'none';
        }
        return defaultValue;
    };

    ctrl.isDeleted = function(data) {
        return (data && data.deleted);
    };

    this.deleteUser = function(event, trns) {
        ConfirmationService.showConfirmationDialog(ctrl.deleteFinal, event,
            selectedListItems.getSelectedItems().length === 1 ? trns.confirmDeleteSingle : trns.confirmDeleteMultiple,
            trns.delete, trns.abort);
    };

    this.deleteFinal = function () {
        var dataObj;
        var resultScope = {};
        var selectedIds = selectedListItems.getSelectedIds();
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        var selectedIdsAsInteger = [];
        for (var i = 0; i < selectedIds.length; i++) {
            selectedIdsAsInteger.push(parseInt(selectedIds[i]));
        }

        if(selectedIdsAsInteger.length > 0) {

            dataGen.postAsForm(resultScope, {usrIds: selectedIdsAsInteger}, "/user/delete").then(function (data) {
                ToastService.openStandardToastAfterDeleteSuccess(resultScope, data);
                ListHelperService.refreshListData($scope, 'userListCtrl', {
                    unselectRows: selectedItems
                });
            });
        }
    };

    this.canCopyUser = function() {
        return selectedListItems.isSingleSelection() && impactX.isDefined($scope, '$$childHead.data.actions.copyUser.allowed') && allowAction();
    };

    this.copyUserDisabled = function() {
        return selectedListItems.isSingleSelection() && impactX.isDefined($scope, '$$childHead.data.actions.copyUser.disabled');
    };

    this.canExportCXML = function() {
        return selectedListItems.isSingleSelection() && impactX.isDefined(selectedListItems.getFirstSelectedItem(), "canExportCXML.value") && allowAction();
    };

    this.copyUser = function () {

        var resultScope = {};

        dataGen.postAsForm(resultScope, {ids: selectedListItems.getSelectedIds()}, "/user/copy").then(function () {

            if (resultScope.data.newUserIds.length === 1 && resultScope.data.newUserIds[0] > 0) {
                $redirect.redirectTo(null, '/personaldata/' + resultScope.data.newUserIds[0]);
            }
            else {
                $redirect.reload();
            }
        })
    };

    this.ghostLogin = function() {
        var dataObj = {
            targetUserId: selectedListItems.getFirstSelectedId()
        };
        dataGen.postAsForm({}, dataObj, "/ghost/login").then(function() {
            $securityManager.invalidateProcesses();
            TranslationService.refresh(dataGen);
            LoginService.refreshUI(true);
        });
    };

    this.requestGhostLogin = function() {
        var item = selectedListItems.getFirstSelectedItem();
        var targetUserId = selectedListItems.getFirstSelectedId();
        if (targetUserId) {
            return ixaUserActions.requestGhostLogin(targetUserId, item ? item.name : undefined).then(function() {
                ListHelperService.refreshListData($scope, 'userListCtrl', {unselectRow: selectedListItems.getFirstSelectedItem()});
            });
        }
    };

    this.ghostLogout = function() {
        var dataObj = {
            targetUserId: selectedListItems.getFirstSelectedId()
        };
        dataGen.postAsForm({}, dataObj, "/ghost/logout").then(function(response) {
            if (response && response.data && response.data.message) {
                ToastService.openStandardToast(response.data.message);
            }
            refreshList();
        });
    };

    this.getSecurityDataLink = function () {
        return 'securitydata/' + selectedListItems.getFirstSelectedId();
    };

    this.setNoOrder = function (event, trns) {

        $mdDialog.show({
            controller: "UserNoOrderCtrl",
            controllerAs: "userNoOrderCtrl",
            templateUrl: "modules/userlist/templates/user-no-order.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                headerLabel: trns.setNoOrder,
                startDateLabel: trns.startDate,
                endDateLabel: trns.endDate,
                usrIds: selectedListItems.getSelectedIds()
            }
        }).then(function () {
            ListHelperService.refreshListData($scope, 'userListCtrl');
        })
    };

    this.approve = function() {
        var dataObj = {
            usrId: selectedListItems.getFirstSelectedId()
        };
        dataGen.postAsForm({}, dataObj, "/user/registration/approve").then(function() {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            refreshList();
        });
    };

    this.deny = function() {
        var dataObj = {
            usrId: selectedListItems.getFirstSelectedId()
        };
        dataGen.postAsForm({}, dataObj, "/user/registration/deny").then(function() {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            refreshList();
        });
    };

    this.doAnonymization = function() {
        ixaUserActions.openUserAnonymizationDialog(selectedListItems.getSelectedIds()).then(function (data) {
            if (data && data.resultId && data.resultId > 0) {
                $redirect.redirectTo(null, "/anonymizationresult/" + data.resultId);
            }
        });
    }

    var allowAction = function(){
        // if any of the selected is not allowed, do not allow actions
        return selectedListItems.isMultiSelection() &&
            selectedListItems.getSelectedItems().filter(function(entry){
                return entry.isAnonymized.value == 1;
            }).length === 0;
    };

    var isSingleSelectionAndAllowAction = function () {
        return selectedListItems.isSingleSelection() && allowAction();
    }

    var buttonDefinition = [
        {
            label: "masterData",
            linkFunction: ctrl.getMaserDataLink,
            type: 'link',
            condition: isSingleSelectionAndAllowAction,
            process: 'EditUser'
        },
        {
            label: "settings",
            linkFunction: ctrl.getSettingsLink,
            type: 'link',
            condition: isSingleSelectionAndAllowAction,
            process: 'EditUser'
        },
        {
            label: "messages",
            linkFunction: ctrl.getMessagesLink,
            type: 'link',
            condition: isSingleSelectionAndAllowAction,
            process: 'EditUser'
        },
        {
            label: "control",
            linkFunction: ctrl.getControlLink,
            type: 'link',
            condition: isSingleSelectionAndAllowAction,
            process: 'EditUser'
        },
        {
            label: "groups",
            linkFunction: ctrl.getGroupsLink,
            type: 'link',
            condition: isSingleSelectionAndAllowAction,
            process: 'EditUser'
        },
        {
            label: "delegation",
            linkFunction: ctrl.getDelegationLink,
            type: 'link',
            condition: isSingleSelectionAndAllowAction,
            process: 'EditUser'
        },
        {label: "ghostLogin", action: ctrl.ghostLogin, condition: ctrl.canDirectGhostLogin, process: 'GhostLogin'},
        {
            label: 'requestGhostLogin',
            action: ctrl.requestGhostLogin,
            condition: ctrl.canRequestGhostLogin,
            process: 'GhostLogin'
        },
        {
            label: 'ghostLoginPending',
            action: angular.noop,
            condition: ctrl.isGhostRequestPending,
            process: 'GhostLogin',
            type: 'validation',
            params: {
                form: { $invalid: true, $error: {} },
                disableExpression: {
                    valueFunction: function() { return true; },
                    errorFunction: function () { return ctrl.meta.trns.ghostLoginPending; }
                }
            }
        },
        {label: "ghostLogout", action: ctrl.ghostLogout, condition: ctrl.canGhostLogout, process: 'GhostLogout'},
        {label: "delete", action: ctrl.deleteUser, condition: ctrl.canDelete, process: 'EditUser'},
        {label: "securityData", linkFunction: ctrl.getSecurityDataLink, type: 'link', condition: isSingleSelectionAndAllowAction, process: 'SecurityData'},
        {label: "copy", action: ctrl.copyUser, condition: ctrl.canCopyUser, process: 'CopyUser', type: 'validation', params: {
            disableExpression: {
                valueFunction: ctrl.copyUserDisabled,
                errorReference: 'data.actions.copyUser.label'
        }}},
        {label: "exportCXML", linkFunction: ctrl.getCXMLExportLink, type: 'link', condition: ctrl.canExportCXML, process: 'CXMLCatalogExport'},
        {label: "customerCompanies", linkFunction: ctrl.getCustomerCompaniesLink, type: 'link', condition: ctrl.canEditCustomerCompanies, process: 'AssignCustomerCompanies'},
        {label: "setNoOrder", action: ctrl.setNoOrder, condition: ctrl.canSetNoOrder, process: 'EditUser'},
        {label: "approve", action: ctrl.approve, condition: ctrl.canApproveAndDeny, process: 'SelfRegistrationUnlock'},
        {label: "deny", action: ctrl.deny, condition: ctrl.canApproveAndDeny, process: 'SelfRegistrationUnlock'},
        {label: "doAnonymization", action: ctrl.doAnonymization, condition: selectedListItems.isMultiSelection, process: 'DoAnonymization'}
    ];

    this.meta = {
        rowTemplate: 'modules/userlist/templates/userlist.row.server.tmpl.html',
        isSelectAble: true,
        enableSelectAllPages: true,
        ctrl: this,
        custom: {
            getCellDecoration: this.getCellDecoration
        },
        endpoint: '/user/list',
        id: 'userlist2',
        mainAction: {id: "new", link: "#/personaldata/0", icon: "mdi-account-star"},
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function() {
        return this.meta;
    };

    function refreshList() {
        ListHelperService.refreshListData($scope, 'userListCtrl', {unselectRow: []});
    }

}